import { createAction, createSlice } from "@reduxjs/toolkit";

const totalSubscriberSlice = createSlice({
  name: "totalSubscriber",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = totalSubscriberSlice;
const totalSubscriberAction = createAction(name);

export {
  totalSubscriberAction,
  actions as totalSubscriberActions,
  reducer as totalSubscriberReducer,
};
